import { multisub } from "@utils/helpers/multi-subscribe"
import { notificationData } from "@utils/practice/notifications-data"
import { clearAllNotifications, currentNativeNotifications } from "./cap-notification-manager"

/**
 * Basically what we want to do here is make so that if the native notifications
 * ever don't match the notification data lesson number, native reminders get cancelled.
 */
multisub(
    [notificationData, currentNativeNotifications],
    (notificationData, currentNativeNotifications) => {
        if (!notificationData) return
        if (!currentNativeNotifications) return
        const notificationLesson = currentNativeNotifications.lesson
        const currentLesson = notificationData.currentLesson
        if (notificationLesson !== currentLesson) {
            console.log(
                `Notification conflict detected between native notifications and set number, clearing notifications.`,
            )
            clearAllNotifications()
        }
    },
)
